import { css } from "@emotion/react";
import { BghomepageMb } from "assets/Mobile/images/homepage";

export const LayoutStyle = {
  root: css``,
  main: () => css`
    background-image: url(${BghomepageMb});
    height: 100vh;
    padding-bottom: 50px !important;
    max-width: 1024px;
    margin: auto;
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: none;
    }
  `,
};
